import * as types from './ActionTypes';

export function setTrailsListNearbyFilterValue(comCoursesListNearbyFilters) {
    return {
        type: types.SET_COMCOURSES_LIST_NEARBY_FILTER_VALUE,
        comCoursesListNearbyFilters: comCoursesListNearbyFilters
    };
}

export function setTrailsListSavedFilterValue(comCoursesListSavedFilters) {
    return {
        type: types.SET_COMCOURSES_LIST_SAVED_FILTER_VALUE,
        comCoursesListSavedFilters: comCoursesListSavedFilters
    };
}

export function setTrailsListNearbySortValue(comCoursesListNearbySortType, callback) {
    return {
        type: types.SET_COMCOURSES_LIST_NEARBY_SORT_VALUE,
        comCoursesListNearbySortType: comCoursesListNearbySortType,
        callback: callback
    };
}

export function setTrailsListSavedSortValue(comCoursesListSavedSortType, callback) {
    return {
        type: types.SET_COMCOURSES_LIST_SAVED_SORT_VALUE,
        comCoursesListSavedSortType: comCoursesListSavedSortType,
        callback: callback
    };
}

export function setTrailsListNearby(trailsListNearby) {
    return {
        type: types.SET_COMCOURSES_LIST_NEARBY,
        nearbyTrails: trailsListNearby
    };
}

export function setTrailsListSaved(trailsListSaved) {
    return {
        type: types.SET_COMCOURSES_LIST_SAVED,
        savedTrails: trailsListSaved
    };
}

export function addTrailToFavorites(trail) {
    return {
        type: types.ADD_COMCOURSE_TO_FAVORITES,
        trail: trail
    };
}
export function removeTrailFromFavorites(curatedCourseId) {
    return {
        type: types.REMOVE_COMCOURSE_FROM_FAVORITES,
        curatedCourseId: curatedCourseId
    };
}

export function resetFavoriteTrails(trails) {
    return {
        type: types.RESET_FAVORITE_COMCOURSES,
        trails: trails
    };
}

export function setFavoritesNotificationData(data) {
    return {
        type: types.SET_FAVORITES_NOTIFICATION_DATA,
        data
    };
}

export function setSuggestEditModalStatus(suggestEditModalOpened) {
    return {
        type: types.SET_SUGGEST_EDIT_MODAL_STATUS,
        suggestEditModalOpened
    };
}

export function setReportIssueModalStatus(reportIssueModalOpened) {
    return {
        type: types.SET_REPORT_ISSUE_MODAL_STATUS,
        reportIssueModalOpened
    };
}

export function setSubmitReviewModalStatus(submitReviewModalOpened) {
    return {
        type: types.SET_SUBMIT_REVIEW_MODAL_STATUS,
        submitReviewModalOpened
    };
}

export function setShareReviewModalStatus(shareReviewModalStatus) {
    return {
        type: types.SET_SHARE_REVIEW_MODAL_STATUS,
        shareReviewModalStatus
    };
}

export function setStarRatingValue(starRatingValue) {
    return {
        type: types.SET_STAR_RATING_VALUE,
        starRatingValue
    };
}

export function setTrailReviewsSortValue(comCourseReviewsSortType) {
    return {
        type: types.SET_COMCOURSE_REVIEWS_SORT_VALUE,
        comCourseReviewsSortType
    };
}

export function setSelectedTrailReview(selectedComCourseReview) {
    return {
        type: types.SET_SELECTED_COMCOURSE_REVIEW,
        selectedComCourseReview
    };
}
export function setSubmitReviewPhotos(submitReviewPhotos) {
    return {
        type: types.SET_SUBMIT_REVIEW_PHOTOS,
        submitReviewPhotos
    };
}

export function setCenterLocationAction(centerLocation) {
    return {
        type: types.SET_CENTER_LOCATION,
        centerLocation
    };
}
export function setSearchedLocationAction(searchedLocation) {
    return {
        type: types.SET_SEARCHED_LOCATION,
        searchedLocation
    };
}

export function setSearchAdditionalData(additionalData) {
    return {
        type: types.SET_SEARCH_ADDITIONAL_DATA,
        additionalData: { ...additionalData }
    };
}

export function setSavedZoomLevel(zoomLevel) {
    return {
        type: types.SET_ZOOM_LEVEL,
        zoomLevel: zoomLevel
    };
}
export function setBoundingBox(boundingBox) {
    return {
        type: types.SET_BOUNDING_BOX,
        boundingBox: boundingBox
    };
}

export function setTrailsError(comCoursesError) {
    return {
        type: types.SET_COMCOURSE_ERROR,
        comCoursesError: comCoursesError
    };
}
